<template>
  <!-- 添加dom记得适应手机端 -->
  <div class="mapcontainer">
    <div class="infoview">
      <input
        id="btnStop"
        @click="flyToPile"
        type="button"
        class="btn btn-primary"
        value="flyTo"
      />
      <input
        v-show="isshow"
        id="btnStop"
        @click="suidao"
        type="button"
        class="btn btn-primary"
        value="视角切换隧道"
      />
      <input
        id="btnStop"
        v-show="isshow"
        @click="qiche"
        type="button"
        class="btn btn-primary"
        value="汽车视角"
      />
      <input
        id="btnStop"
        v-show="isshow"
        @click="stop"
        type="button"
        class="btn btn-primary"
        value="停止跟随汽车"
      />
    </div>
    <Map :url="configUrl" @onload="onMapload" />
  </div>
</template>

<script>
import Map from "../components/mars3d/Map.vue";
import { isPC } from "../../static/util/pqtutil";
let ispc = true;
export default {
  components: {
    Map,
  },
  data() {
    const basePathUrl = window.basePathUrl || "";
    const scale = 1;
    return {
      isshow: false,
      configUrl: basePathUrl + "static/mapconfig/config.json", // 配置文件
      pileJsonUrl: basePathUrl + "static/mapconfig/pileJson.json", // 图层生成json数据
      drawer: false,
      drawerUrl: "",
      // 客户端环境
      ispc: ispc,
      // 地图对象
      map: {},
      // 桩在地图上缩放的比例
      pileScale: scale,
      // 地形开挖对象
      terrainClip: {},
      // 开挖矩形区域参数

      // 开挖深度 * 缩放比例
      clipHeight: 36 * scale,
      // 开挖记录对象数组
      areaItems: [],
      // 桩图层
      pileGraphicLayer: {},
      // 桩数据
      piles: [],
      // 未施工桩图层
      otherPileGraphicLayer: {},
      // 未施工桩数据
      otherPiles: [],
      // 曲线数据
      chartData: {},
      // 曲线option
      chartOption: [
        { title: "电流" },
        { title: "深度" },
        { title: "填料量" },
        { title: "瞬时水量" },
        { title: "瞬时水压" },
      ],
      // 曲线是否显示
      showLeftChart: false,
      showRightChart: false,
      showLeftChart1: false,
      showLeftChart2: false,
      showRightChart1: false,
      showRightChart2: false,
      showRightChart3: false,
      askurl: "http://mcc.wedam.com.cn/zhenchongearth",
       // askurl: "",
    };
  },
  beforeCreate() {
    ispc = isPC(navigator.userAgent);
    let script3 = document.createElement("script");
    script3.type = "text/javascript";
    script3.src = "http://mcc.wedam.com.cn/zhenchongearth/static/mapconfig/CanvasBillboard.js";
    document.head.appendChild(script3);
  },
  methods: {
    // 地图构造完成回调
    onMapload(map) {
      console.log("地图构造完成");
      this.map = map;
      // this.startRotate()
      // this.initTerrainClip()
      // this.initPileGraphicLayer()
    },
    stop() {
      const { map } = this;
      this.qiche.stop();
      map.setCameraView({
        lat: 31.843542,
        lng: 117.251754,
        alt: 33,
        heading: 270,
        pitch: 0,
      });
    },
    suidao() {
      const { map } = this;
      map.setCameraView({
        lat: 31.843542,
        lng: 117.251754,
        alt: 33,
        heading: 270,
        pitch: 0,
      });
    },
    qiche() {
      const { map } = this;
      var graphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer);
      var flydata = {
        name: "室内路线",
        speed: 30,
        positions: [
          [117.251754, 31.843542, 30],
          [117.250475, 31.843526, 30],
        ],
        camera: {
          type: "dy",
          followedX: 1,
          followedZ: 0.2,
        },
        offsetHeight: 1.6,
      };

      var roamLine = new mars3d.graphic.RoamLine(flydata);
      graphicLayer.addGraphic(roamLine);

      roamLine.start();
      this.qiche = roamLine;
    },
    // 跳转到桩
    flyToPile() {
      this.isshow = true;
      const { map } = this;
      this.stopRotate();
      let that = this;
      //map.flyToExtent(extent, options)
      if (this.areaItems.length === 0) {
        // 添加一个坑区域
        // this.drawExtentClip()
      }
      //  let graphicLayer = new mars3d.layer.GraphicLayer()
      //  map.addLayer(graphicLayer);

      let tiles3dLayer = new mars3d.layer.TilesetLayer({
        name: "杜能",
        // url: "http://mcc.wedam.com.cn/zhenchongearth/static/mapconfig/aa/tileset.json",
        url: that.askurl + "/static/helmet/Production_1.json",
        position: { lng: 117.251099, lat: 31.843504, alt: 0 },
        maximumScreenSpaceError: 16,
        maximumMemoryUsage: 1024,
        dynamicScreenSpaceError: true,
        cullWithChildrenBounds: false,
        skipLevelOfDetail: true,
        preferLeaves: true,
        scale: 20, //缩放比例
        highlight: {
          type: mars3d.EventType.click, //默认为鼠标移入高亮，也可以指定click单击高亮
          color: "#00FF00",
        },
        popup: "all",
        show: true,
        //center: { lat: 28.439577, lng: 102.2149, alt: 229, heading: 1000, pitch: -29 },
        flyTo: true,
      });
      map.addLayer(tiles3dLayer);

      //加载的事件 只执行一次
      tiles3dLayer.on(mars3d.EventType.initialTilesLoaded, function (event) {
        console.log("触发initialTilesLoaded事件", event);
      });

      //会执行多次，重新加载一次完成后都会回调
      tiles3dLayer.on(mars3d.EventType.allTilesLoaded, function (event) {
        console.log("触发allTilesLoaded事件", event);
      });

      tiles3dLayer.on(mars3d.EventType.click, function (event) {
        let pickedItem = event.graphic.attr.name;
        console.log("单击了合并对象中的单个值为", pickedItem);
      });

      let graphicLayer = new mars3d.layer.GraphicLayer();
      map.addLayer(graphicLayer);

      var roamLine = new mars3d.graphic.RoamLine({
        positions: [
          [117.251754, 31.843542, 20],
          [117.250475, 31.843526, 20],
        ],
        speed: 30,
        model: {
          show: true,
          url: that.askurl + "/static/mapconfig/suidao/qiche.gltf",
          scale: 0.2,
        },
        // path: {
        //   color: "#ffff00",
        //   width: 3,
        //   show: true,
        // },
        clockLoop: true, //是否循环播放
      });
      graphicLayer.addGraphic(roamLine);

      // roamLine.bindPopup(`<div style="width: 200px">
      //       <div>C88：<span id="lblAllLen"> </span></div>
      //       <div>C89：<span id="lblAllTime"> </span></div>
      //       <div>我是当前秒：<span id="ss"> </span></div>
      //     </div>`);
      // roamLine.openPopup();
      roamLine.on(mars3d.EventType.change, function (event) {
       
              graphic.text = (Math.random()*100+"").substring(0,2); //更新文本
              var po = event.position
              po.z = po.z+10
              graphic.position = po; //更新文本

        // var myDate = new Date();
        // let container = event.container; //popup对应的DOM
        // let lblAllLen = container.querySelector("#lblAllLen");
        // if (lblAllLen) {
        //   lblAllLen.innerHTML = myDate.getSeconds();
        // }

        // let lblAllTime = container.querySelector("#lblAllTime");
        // if (lblAllTime) {
        //   lblAllTime.innerHTML = myDate.getSeconds();
        // }

        // let ss = container.querySelector("#ss");
        // if (ss) {
        //   ss.innerHTML = myDate.getSeconds();
        // }
      });
      //启动漫游
      roamLine.start();

      var graphic = new mars3d.graphic.CanvasBillboard({
        position: [117.251111, 31.843514, 20],
        style: {
          text: 18,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          scaleByDistance: new Cesium.NearFarScalar(800, 0.4, 1200, 0.2),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(
            0,
            1000
          ),
          
        },
      });
      graphicLayer.addGraphic(graphic);

      window.setInterval(function (){

      },1000);
      var particleSystem = new mars3d.graphic.ParticleSystem({
        modelMatrix: (time) => {
          return roamLine.modelMatrix;
        },
        style: {
          image: "http://mars3d.cn/example/img/particle/smoke.png",
          startColor: Cesium.Color.GREY.withAlpha(0.7), //粒子出生时的颜色
          endColor: Cesium.Color.WHITE.withAlpha(0.0), //当粒子死亡时的颜色
          startScale: 1.0, //粒子出生时的比例，相对于原始大小
          endScale: 5.0, //粒子在死亡时的比例
          minimumParticleLife: 1.2, //设置粒子寿命的可能持续时间的最小界限（以秒为单位），粒子的实际寿命将随机生成
          maximumParticleLife: 1.2, //设置粒子寿命的可能持续时间的最大界限（以秒为单位），粒子的实际寿命将随机生成
          minimumSpeed: 1.0, //设置以米/秒为单位的最小界限，超过该最小界限，随机选择粒子的实际速度。
          maximumSpeed: 4.0, //设置以米/秒为单位的最大界限，超过该最大界限，随机选择粒子的实际速度。
          emissionRate: 20.0, //每秒要发射的粒子数。
          lifetime: 16.0, //粒子的生命周期为（以秒为单位）。
        },
        transX: -4.0,
        transZ: 1.4,
        maxHeight: 1000, //超出该高度后不显示粒子效果
      });
      map.graphicLayer.addGraphic(particleSystem);

      var particleSystem = new mars3d.graphic.ParticleSystem({
        position: Cesium.Cartesian3.fromDegrees(117.251471, 31.843677, 20), //位置
        style: {
          image: "http://mars3d.cn/example/img/particle/fountain2.png",
          startColor: new Cesium.Color(1, 1, 1, 0.6), //粒子出生时的颜色
          endColor: new Cesium.Color(0.8, 0.86, 1, 0.4), //当粒子死亡时的颜色

          particleSize: 4, //粒子图片的Size大小（单位：像素）
          startScale: 1.0, //粒子在出生时的比例（单位：相对于imageSize大小的倍数）
          endScale: 4.0, //粒子在死亡时的比例（单位：相对于imageSize大小的倍数）

          minimumParticleLife: 6, //粒子可能存在的最短寿命时间，实际寿命将随机生成（单位：秒）
          maximumParticleLife: 7, //粒子可能存在的最长寿命时间，实际寿命将随机生成（单位：秒）

          minimumSpeed: 9.0, //粒子初速度的最小界限，超过该最小界限，随机选择粒子的实际速度。（单位：米/秒） ？？？
          maximumSpeed: 9.5, //粒子初速度的最大界限，超过该最大界限，随机选择粒子的实际速度。（单位：米/秒）

          emissionRate: 40, //粒子发射器的发射速率 （单位：次/秒）
          // lifetime: 16, //粒子的一个生命周期长度（单位：秒） ？？？
        },
        transZ: 5, //离地高度
        gravity: -3.5, //重力因子，会修改速度矢量以改变方向或速度（基于物理的效果）
        maxHeight: 500, //超出该高度后不显示粒子效果
      });

      graphicLayer.addGraphic(particleSystem);

      var particleSystem = new mars3d.graphic.ParticleSystem({
        position: Cesium.Cartesian3.fromDegrees(117.251477, 31.843349, 20), //位置
        style: {
          image: "http://mars3d.cn/example/img/particle/fire4.png",
          startColor: new Cesium.Color(1, 1, 1, 1), //粒子出生时的颜色
          endColor: new Cesium.Color(0.5, 0, 0, 0), //当粒子死亡时的颜色
          // sizeInMeters: true,

          particleSize: 3, //粒子图片的Size大小（单位：像素）
          startScale: 2.0, //粒子在出生时的比例（单位：相对于imageSize大小的倍数）
          endScale: 1, //粒子在死亡时的比例（单位：相对于imageSize大小的倍数）

          minimumParticleLife: 1, //粒子可能存在的最短寿命时间，实际寿命将随机生成（单位：秒）
          maximumParticleLife: 1.8, //粒子可能存在的最长寿命时间，实际寿命将随机生成（单位：秒）

          minimumSpeed: 7.0, //粒子初速度的最小界限，超过该最小界限，随机选择粒子的实际速度。（单位：米/秒） ？？？
          maximumSpeed: 9.0, //粒子初速度的最大界限，超过该最大界限，随机选择粒子的实际速度。（单位：米/秒）

          emissionRate: 200, //粒子发射器的发射速率 （单位：次/秒）
          // lifetime: 16, //粒子的一个生命周期长度（单位：秒） ？？？
        },
        transZ: 5, //离地高度
        gravity: 0.0, //重力因子，会修改速度矢量以改变方向或速度（基于物理的效果）
        maxHeight: 500, //超出该高度后不显示粒子效果
      });
      graphicLayer.addGraphic(particleSystem);

      // let firstPersonRoam = new mars3d.thing.FirstPersonRoam();
      // map.addThing(firstPersonRoam);

      // firstPersonRoam.startAutoForward();
    },
    // 地球旋转
    startRotate() {
      const { map, mars3d } = this;
      // 距离地面过近时，先回到初始状态
      if (map.getCameraDistance() < 1000000) {
        map.flyHome({ duration: 3 });
      }
      this.stopRotate();

      this.previousTime = map.clock.currentTime.secondsOfDay;
      map.on(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    stopRotate() {
      const { map, mars3d } = this;
      map.off(mars3d.EventType.clockTick, this.map_onClockTick);
    },
    map_onClockTick(clock) {
      const { map } = this;
      let spinRate = 150;
      let currentTime = map.clock.currentTime.secondsOfDay;
      let delta = (currentTime - this.previousTime) / 1000;
      this.previousTime = currentTime;
      map.scene.camera.rotateRight(-spinRate * delta);
    },
  },
};
</script>

<style >
.mapcontainer {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.infoview {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 0.2rem;
  border: 1px solid rgba(128, 128, 128, 0.5);
  color: #ffffff;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0.2rem 0.9rem rgb(128 128 128 / 50%);
  z-index: 19870101;
}
.btn {
  display: inline-block;
  padding: 0.4rem 0.8rem;
  margin-bottom: 0;
  font-size: 0.8rem;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  outline: none;
}
.btn-primary {
  color: #fff;
  background-color: rgba(32, 160, 255, 0.2);
  border: 1px solid #e4eaec;
}
.checkbox {
  padding-left: 0.3rem;
}
.checkbox-inline {
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  font-weight: normal;
  vertical-align: middle;
  cursor: pointer;
}
input[type="checkbox"] {
  width: 0.8rem;
  height: 0.8rem;
}
.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-bottom: 0.3rem;
}
.right-charts {
  z-index: 800;
  position: absolute;
  right: 22rem;
  top: 10px;
  font-size: 0.9rem;
  border: none;
  color: #ffffff;
  background: none;
}
.left-charts {
  z-index: 800;
  position: absolute;
  left: 0px;
  top: 9rem;
  font-size: 0.8rem;
  border: none;
  color: #ffffff;
  background: none;
}
.phoneCharts {
  height: 13rem;
  overflow: auto;
}
.rightPhoneCharts {
  right: 3rem !important;
}
.pcCharts1 {
  position: absolute !important;
}
.pcCharts2 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts3 {
  position: absolute !important;
}
.pcCharts4 {
  position: absolute !important;
  top: 10.5rem;
}
.pcCharts5 {
  position: absolute !important;
  top: 21rem;
}
</style>


// WEBPACK FOOTER //
// src/components/suidao.vue